import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import Badge from "../../../theme/untitled/Badge/Badge";
import { AvailableIntegrations, IntegrationStatus } from "../../../consts/integrations";
import {
  getSourceLevel,
  getSourceStatusLabel,
  getSourceName,
  formatRelativeTime,
} from "./utils";

const BADGE_COLOR = {
  healthy: "success",
  failed: "error",
  pending: "gray",
};

/**
 * One calendar source row: logo, name + last-synced meta, status badge,
 * and — only on a failed source — a Reconnect button in place of a count
 * (there's no reliable per-source events-synced figure to show instead;
 * see CalendarSourcesWidget/index.js for why).
 *
 * @param {Object} props
 * @param {Object} props.integration
 */
const SourceRow = ({ integration }) => {
  const history = useHistory();
  const meta = AvailableIntegrations.find((a) => a.type === integration.type);
  const level = getSourceLevel(integration.status);
  // IntegrationsPage.js's deep-link contract: reAuthRequired goes straight
  // to the provider, anything else failed opens the Settings dialog.
  const reconnectTarget =
    integration.status === IntegrationStatus.reAuthRequired
      ? `/integrations?reauth=${integration.uuid}`
      : `/integrations?settings=${integration.uuid}`;
  const onReconnect = useCallback(
    () => history.push(reconnectTarget),
    [history, reconnectTarget]
  );

  return (
    <div className="csw-row">
      <span className="csw-logo">
        {meta ? (
          <img src={`/img/integrations_icons/${meta.icon}`} alt="" />
        ) : null}
      </span>
      <span className="csw-who">
        <span className="csw-name">{getSourceName(integration)}</span>
        <span className="csw-meta">
          {integration.last_sync
            ? `Synced ${formatRelativeTime(integration.last_sync)}`
            : "Not synced yet"}
        </span>
      </span>
      <span className="csw-right">
        {level === "failed" && (
          <button
            type="button"
            className="csw-btn-secondary"
            onClick={onReconnect}
          >
            Reconnect
          </button>
        )}
        <Badge color={BADGE_COLOR[level]} dot>
          {getSourceStatusLabel(integration.status)}
        </Badge>
      </span>
    </div>
  );
};

export default SourceRow;
